export default {
  prepareSequenceImages: Array(31)
    .fill('')
    .map((v, i) =>
        require(`../../../Box_sequences/00_TV_clean_box/TV_clean_box${i < 10 ? `0${i}` : i}.jpg`)
    ),
    designSliderImage: require('../../../product drawing/magazine rack.png'),
    designImageList: [
      {
        number: 1,
        // text: "❶",
        side: 'BACK',
        image: require('../../../parts/magazine_rack/1.png'),
      },
      {
        number: 2,
        // text: "❷",
        side: 'MIDDLE',
        image: require('../../../parts/magazine_rack/2.png'),
      },
      {
        number: 3,
        // text: "❸",
        side: 'MIDDLE',
        image: require('../../../parts/magazine_rack/3.png'),
      },
      {
        number: 4,
        // text: "❹",
        side: 'FRONT',
        image: require('../../../parts/magazine_rack/4.png'),
      },
      {
        number: 5,
        // text: "❺",
        side: 'LEFT',
        image: require('../../../parts/magazine_rack/5.png'),
      },
      {
        number: 6,
        // text: "❻",
        side: 'RIGHT',
        image: require('../../../parts/magazine_rack/6.png'),
      },
      {
        number: 7,
        // text: "❼",
        side: 'BOTTOM',
        image: require('../../../parts/magazine_rack/7.png'),
      },
    ],
    cutOutPartsImage: require('../../../parts/magazine_rack/cut.png'),
  assembleSequenceImages: Array(61)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/03_magazine_sequence/magazine${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/magazinerack.png'),
  completeImagePc: require('../../../complete/magazinerack.png'),
};
